package com.wintermar.inspection.feature.domain.model.template

import com.wintermar.inspection.graphql.type.InspectionAnswerType

data class TemplateOptionModel(
    val id: String = "",
    val order: Int = 0,
    val label: String = "",
    val answerType: InspectionAnswerType = InspectionAnswerType.UNKNOWN__
)
